import axios from "axios";
import { GetUserReviewsResponse } from "./dto/UserReview";

export const getUserDeals = async (): Promise<GetUserReviewsResponse> => {
  const res = await axios.get<GetUserReviewsResponse>("/api/users/deal/list", {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};
